import { Component } from '@angular/core';

@Component({
    selector: 'app-detail-settings',
    templateUrl: './detail-settings.component.html',
    styleUrls: ['./detail-settings.component.scss'],
})
export class DetailSettingsComponent {}
